import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { review_rating_chart } from "../../sample-data";


const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchReviewStat = createAsyncThunk(
  "ReviewStat/fetchReviewStat",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 200));  
    return review_rating_chart;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReviewStat = createSlice({
  name: "ReviewStat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewStat.pending, (state) => {
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchReviewStat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchReviewStat.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectReviewStatData = (state) => state.ReviewStat.data;
export const selectIsLoading = (state) => state.ReviewStat.isLoading;
export const selectError = (state) => state.ReviewStat.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.ReviewStat.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.ReviewStat.data,
  isLoading: state.ReviewStat.isLoading,
  error: state.ReviewStat.error,
}));
*/
export default sliceReviewStat.reducer; // Export the reducer
